class VariantSelects extends HTMLElement {
    constructor() {
        super();
        if (document.querySelector('.variant-row.Farbe')){
            this.colorTitleBlock = document.querySelector('.variant-row.Farbe .variatn-title-item.title');
            this.colorItems = document.querySelectorAll('.variant-row.Farbe .variant-options-item');
        }else{
            this.variantTitleBlock = document.querySelector('.variant-row .variatn-title-item.title');
            this.variantItems = document.querySelectorAll('.variant-row .variant-options-item');
        }
        if (document.querySelector('.variant-row.Colour')){
            this.colorTitleBlock = document.querySelector('.variant-row.Colour .variatn-title-item.title');
            this.colorItems = document.querySelectorAll('.variant-row.Colour .variant-options-item');
        }else{
            this.variantTitleBlock = document.querySelector('.variant-row .variatn-title-item.title');
            this.variantItems = document.querySelectorAll('.variant-row .variant-options-item');
        }
        if (document.querySelector('.variant-row.Color')){
            this.colorTitleBlock = document.querySelector('.variant-row.Color .variatn-title-item.title');
            this.colorItems = document.querySelectorAll('.variant-row.Color .variant-options-item');
        }else{
            this.variantTitleBlock = document.querySelector('.variant-row .variatn-title-item.title');
            this.variantItems = document.querySelectorAll('.variant-row .variant-options-item');
        }
        this.addEventListener('change', this.onVariantChange);
        this.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                this.click();
            }
        });
        this.updatePrice();
        this.updateOptionsAvailability();
        if (document.querySelector('.variant-row.Farbe') || document.querySelector('.variant-row.Colour') || document.querySelector('.variant-row.Color')){
            this.variantsMediaIcon();
        }
        this.defaultId = '';
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateURL();
            this.updatePrice();
            this.updateVariantInput();
            this.updateShareUrl();
            this.updateOptionsAvailability();
            this.showMedia()
        }
    }

    variantsMediaIcon() {
        this.colorItems.forEach((item) => {
            let itemData = item.dataset.option;
            let itemId = this.getVariantData().find(variant => variant.option1.replace(/ /g, '_') === itemData);
            let imgSrc = itemId.featured_image;
            let img = new Image();
            let canvas = item.querySelector('canvas');
            let ctx = canvas.getContext('2d');
            img.onload = function() {
                let width = 128;
                let height = 192;
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
            }
            img.src = imgSrc;
            // item.style.backgroundImage = `url('${imgSrc}')`;
            item.dataset.id = itemId.metafieldBildmapping;
        });
    }

    mediaLoop(target) {
        const mediaItems = document.querySelectorAll('.product-single__media .product-single__media-item');
        let count = 0;
        mediaItems.forEach((elem, ind) => {
            elem.classList.add('hidden');
            elem.classList.remove('active');
            elem.classList.remove('first');
            elem.classList.remove('w-full');
            elem.classList.remove('w-1/2');
            if (elem.dataset.src.includes(target)) {
                elem.classList.remove('hidden');
                elem.classList.add('active');
                elem.classList.add('w-1/2');
                if (count == 0) {
                    elem.classList.add('first');
                    elem.classList.add('w-full');
                    elem.classList.remove('w-1/2');
                }
                if (count == 1) {
                    elem.classList.add('second');
                    elem.classList.add('w-full');
                    elem.classList.remove('w-1/2');
                }
                count++;
            }
        });
    }

    showMedia() {
        let activeItem = this.currentVariant.metafieldBildmapping;
        this.mediaLoop(activeItem);
    }

    updateOptionsAvailability() {
        const searchParams = new URLSearchParams(window.location.search);
        const variantId = searchParams.get('variant');
        const htmlElements = document.querySelectorAll('.variant-row .variant-options-item');
        const productFormAction = document.querySelector('.product-form .product-form__submit');
        const shippinfInfo = document.querySelector('.shipping_info');
        let variantAvaliable;
        let currentVariantAvaliable;
        let currentVariantColor;
        let variantColor;
        let variantSize;
        if (variantId) {
            htmlElements.forEach((item) => {
                item.classList.add('unavailable');
            });
            this.getVariantData().filter((variant) => {
                if (variantId == variant.id) {
                    currentVariantAvaliable = variant.available;
                    currentVariantColor = variant.option1
                };
                setTimeout(function() {
                    variantAvaliable = variant.available;
                    variantColor = variant.option1;
                    variantSize = variant.option2;
                    if (variantAvaliable && variantColor == currentVariantColor) {
                        let htmlElement;
                        if(variantSize){
                            htmlElement = document.querySelector(`.variant-row .variant-options-item[data-option="${variantSize}"`);
                        }else{
                            htmlElement = document.querySelector(`.variant-row .variant-options-item`);
                        }
                        htmlElement.classList.remove('unavailable')
                    }
                    if (currentVariantAvaliable) {
                        productFormAction.classList.remove('hidden');
                        shippinfInfo.classList.remove('hidden');
                    } else {
                        productFormAction.classList.add('hidden');
                        shippinfInfo.classList.add('hidden');
                    }
                }, 150)
            });
        }
    }

    updatePrice() {
        const searchParams = new URLSearchParams(window.location.search);
        const variantId = searchParams.get('variant');
        if (variantId) {
            const priceItemAll = document.querySelectorAll('.product-single__price-box');
            priceItemAll.forEach(element => {
                element.classList.add('hidden');
            });
            let priceItem = document.querySelector(`.product-single__price-box.id-${variantId}`);
            priceItem.classList.remove('hidden');
        }
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`.product-form, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }
        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.querySelector(`.product-single .product-form`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
        this.updateOptions();
    }

    scrollToTop() {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    updateOptions() {
        this.scrollToTop();
        const fieldsets = Array.from(this.querySelectorAll('.variant-row'));
        let variantLists = document.querySelectorAll('.variant-options-item');
        variantLists.forEach(element => {
            element.classList.remove('active');
        });
        this.options = fieldsets.map((fieldset) => {
            const checkedFields = Array.from(fieldset.querySelectorAll('.variant-options-item input')).find((radio) => radio.checked);
            checkedFields.parentNode.classList.add('active');
            return checkedFields.value;
        });
        if(document.querySelector('.variant-row.Farbe') || document.querySelector('.variant-row.Colour') || document.querySelector('.variant-row.Color')){
            this.colorTitleBlock.innerHTML = this.options[0];
        }else{
            this.variantTitleBlock.innerHTML = this.options[0];
        }
        this.defaultId = this.getVariantData().find(variant => JSON.stringify(variant.options) === JSON.stringify(this.options)).metafieldBildmapping;
        this.mediaLoop(this.defaultId);
    }
}

customElements.define('variant-radios', VariantRadios);